import colors from '../../../theming/themes/alucio/colors';
import React from 'react';
import { StyleSheet, Pressable } from 'react-native';
import { luxColors, DNADivider, Icon, DNABox, DNAText } from '../../../index';
const S = StyleSheet.create({
    Container: {
        marginTop: 16,
        width: 392,
        height: 68,
        borderRadius: 4,
        borderColor: luxColors.border.primary,
        borderWidth: 1,
    },
    Highlight: {
        backgroundColor: 'rgba(48,173,127,0.08)',
        borderColor: '#D6EFE5',
        borderWidth: 1,
    },
    Icon: {
        width: 20,
        height: 20,
        color: colors['color-gray-500'],
    },
    IconHighlight: {
        color: luxColors.warning.quaternary,
    },
    IconNotification: {
        width: 22,
        height: 22,
        color: luxColors.basicBlack.primary,
    },
    NotificationAction: {
        color: luxColors.primary.primary,
    },
    NotificationSecondary: {
        color: luxColors.basicBlack.secondary,
    },
    NotificationPrimary: {
        color: '#494949',
    },
    NotificationHighlight: {
        color: luxColors.success.tertiary,
    },
    NotificationsContainer: {
        borderRadius: 8,
        padding: 16,
        backgroundColor: luxColors.info.primary,
        borderWidth: 0,
        shadowColor: luxColors.basicBlack.primary,
        shadowOffset: {
            width: 0,
            height: 4,
        },
        shadowOpacity: 0.16,
        shadowRadius: 11.22,
        width: 440,
        maxHeight: 540,
    },
});
const DNANotificationsItem = (props) => {
    const dateStyle = props.highlight ? S.NotificationHighlight : S.NotificationSecondary;
    const descriptionStyle = props.highlight ? S.NotificationHighlight : S.NotificationPrimary;
    const actionStyle = props.highlight ? S.NotificationHighlight : S.NotificationAction;
    return (<Pressable onPress={props.onPress}>
      <DNABox appearance="row" style={[S.Container, props.highlight && S.Highlight]}>
        <DNABox alignX="center" alignY="center" style={{ width: 56 }}>
          <Icon style={[S.Icon, props.highlight && S.IconHighlight]} name={props.icon}/>
        </DNABox>

        <DNABox appearance="col" alignY="center" style={{
            width: 200,
        }}>
          <DNAText caption style={[dateStyle, { fontSize: 11, lineHeight: 20 }]}>
            {props.date.toUpperCase()}
          </DNAText>
          <DNAText bold={props.highlight} style={descriptionStyle}>
            {props.shortDescription}
          </DNAText>
        </DNABox>
        <DNABox appearance="col" alignY="center">
          <DNAText style={actionStyle}>
            {`${props.actionLabel} >`}
          </DNAText>
        </DNABox>
      </DNABox>
    </Pressable>);
};
const DNANotifications = (props) => {
    const { onPress, items } = props;
    return (<DNABox appearance="col" style={S.NotificationsContainer}>

      <Pressable onPress={onPress}>
        <DNABox appearance="row" alignY="center">
          <DNAText testID="notification-nav-button" h5 style={{ marginBottom: 4 }}>Notifications</DNAText>
          <Icon style={S.IconNotification} name="chevron-right"/>
        </DNABox>

      </Pressable>

      <DNADivider style={{ marginTop: 16 }}/>
      {items.map(item => (<DNANotificationsItem key={item.shortDescription} {...item}/>))}
    </DNABox>);
};
export default DNANotifications;
//# sourceMappingURL=DNANotifications.js.map